import axios from 'axios'
const tok ='1551094d-975e-4fec-8c6a-c37946a23717'
const urlBase ='https://www.lefisc.com.br/api/mapatributario'

export default{
    TodasEstados(){       
        return axios
        .get(`https://www.lefisc.com.br/api/covid19/estados/7c555a0cc655264a9455770359ffb7d9`)
        .then(res=> res.data)   
        .catch(err=> err.response)
    },
    Ncm(ncm){       
        return axios
        .post(`${urlBase}/ListaFederalNCMS/${tok}`,[{"ncm":ncm}])
        .then(res=> res.data)   
        .catch(err=> err.response)
    },
    VerificaNcm(ncm){
        return axios
        .post(`${urlBase}/ValidaNCMS/${ncm}/${tok}`,[{"ncm":ncm}])
        .then(res=> res.data)   
        .catch(err=> err.response)
    },
        NcmEstadoSandBox(ncm,uf){       
        return axios
        .post(`${urlBase}/ListaESTADUAL_NCMS_ICMS/${tok}`,[{"NCM":ncm,"uf":uf}])
        .then(res=> res.data)
        .catch(err=> err.response)
    },
    NcmEstado(ncm,uf){       
        return axios
        .post(`${urlBase}/ListaESTADUAL_NCMS_ICMS/${tok}`,[{"NCM":ncm,"uf":uf}])
        .then(res=> res.data)   
        .catch(err=> err.response)
    },
    getST(ncm,uf){       
        return axios
        .get(`https://www.lefisc.com.br/api/st/simulador/mapa-tributario?ncm=${ncm}&uf=${uf}`)
        .then(res=> res.data)   
        .catch(err=> err.response)
    },

    
}